module.exports = __webpack_public_path__ + "img/GB.0ae120ba.png";